"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get_finale_parties_score = exports.get_parties_score = exports.get_evaluation = exports.get_percent = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var get_percent = function get_percent(max, score) {
  return max ? parseInt(100 * score / max) : 0;
};

exports.get_percent = get_percent;

var get_evaluation = function get_evaluation(score, evaluations) {
  var evaluation = "en phase de calcul intense";
  evaluations.map(function (ev) {
    // avec des <= aux deux tests et en partant du principe que les évaluations
    // sont listées en ordre croissant,
    //    - pour un score de 50
    //    - avec 2 ranges: 0-50 | 50-100
    // on est à true pour les 2 ranges, mais comme on passe 2 fois c'est l'évaluation
    // la plus haute qui est prise en compte
    if (score >= ev.min && score <= ev.max) {
      evaluation = ev;
    }

    return evaluation;
  });
  return evaluation;
};

exports.get_evaluation = get_evaluation;

var get_parties_score = function get_parties_score(questions, parties, results) {
  // console.log("on calcul avec", questions, parties, results)
  // FIXME
  // Il y a moyen de merger cette fonction get_parties_score avec
  // le hook présent dans le provider qui calcul le score global.
  // a priori on loop sur results et on peut glisser l'accumulteur
  // existant ici, juste avant le parties.map
  // Et on retourne un objet { globalscore: accumulateur, scores: buffer}
  // MAIS, même si ce sera pratique et bienvenu, est-ce la bonne manière de faire ?
  // On n'applique pas les memes traitements:
  // - globalScore, buildé sur un hook à chaque chgt de results, fait un dispatch dans
  // le contexte
  // - le "scores", est callé via l'api normallement en statique mais ya ptet eu dérapage :/
  // n'impacte pas le contexte ...
  var buffer = {};

  if (results && results.length) {
    results.map(function (res) {
      var _questions$filter = questions.filter(function (q) {
        return q.id === res.question_id;
      }),
          _questions$filter2 = _slicedToArray(_questions$filter, 1),
          refQuest = _questions$filter2[0];

      if (refQuest && refQuest.choices && refQuest.choices.length) {
        if (refQuest.type === "bool") {
          // Traitement type bool / radio
          var _refQuest$choices$fil = refQuest.choices.filter(function (c) {
            return c.id === res.response_id;
          }),
              _refQuest$choices$fil2 = _slicedToArray(_refQuest$choices$fil, 1),
              choice = _refQuest$choices$fil2[0];

          if (choice) {
            parties.map(function (partie, idx) {
              if (partie.questions.indexOf(refQuest.id) !== -1) {
                var actual_score = (buffer[idx] && buffer[idx].score || 0) + choice.score;
                var actual_percent = get_percent(partie.maxScore, actual_score);
                buffer = _objectSpread({}, buffer, _defineProperty({}, idx, {
                  label: partie.label,
                  evaluations: partie.evaluations,
                  score: actual_score,
                  percent: actual_percent,
                  evaluation: get_evaluation(actual_percent, partie.evaluations),
                  max: partie.maxScore,
                  maxQuestions: partie.questions.length,
                  graph: partie.graph
                }));
              }

              return partie;
            });
          }
        } else {
          // Traitement type multi / checkboxes
          var choices = refQuest.choices.filter(function (c) {
            return res.response_id && res.response_id.length && res.response_id.indexOf(c.id) !== -1;
          });

          if (choices && choices.length) {
            choices.map(function (choice) {
              parties.map(function (partie, idx) {
                if (partie.questions.indexOf(refQuest.id) !== -1) {
                  var actual_score = (buffer[idx] && buffer[idx].score || 0) + choice.score;
                  var actual_percent = get_percent(partie.maxScore, actual_score);
                  buffer = _objectSpread({}, buffer, _defineProperty({}, idx, {
                    label: partie.label,
                    evaluations: partie.evaluations,
                    score: actual_score,
                    percent: actual_percent,
                    evaluation: get_evaluation(get_percent(partie.maxScore, actual_score), partie.evaluations),
                    max: partie.maxScore,
                    maxQuestions: partie.questions.length,
                    graph: partie.graph
                  }));
                }

                return partie;
              });
              return choice;
            });
          }
        }
      }

      return res;
    });
  } // console.dir("Score par Parties", buffer);


  return buffer;
};

exports.get_parties_score = get_parties_score;

var get_finale_parties_score = function get_finale_parties_score(questions, parties, results) {
  var required_questions = parties.map(function (partie) {
    var partie_questions = questions.filter(function (q) {
      return partie.questions.indexOf(q.id) !== -1 && !q.optional;
    });
    return partie_questions;
  }); // const required_questions_ids = required_questions.map( q => q.id )

  var required_questions_ids = parties.map(function (partie) {
    var partie_questions = questions.filter(function (q) {
      return partie.questions.indexOf(q.id) !== -1 && !q.optional;
    });
    return partie_questions.map(function (q) {
      return q.id;
    });
  });
  var required_questions_length = required_questions.map(function (q) {
    return q.length;
  });
  var response = {
    required_questions: required_questions,
    required_questions_ids: required_questions_ids,
    required_questions_length: required_questions_length
  }; // console.log("nbr reponse minimum pour valider chaque 'partie'", response)

  return response;
};

exports.get_finale_parties_score = get_finale_parties_score;